<script setup>
  import { ref, computed } from 'vue';
  import { SearchIcon } from '@imaios-js/icons/stroke24';
  import { CrossSmallIcon } from '@imaios-js/icons/stroke16';
  import { useItemListStore } from '../plugins/store/itemsList.store';

const model = defineModel();
const props = defineProps({
    onFocus: Function
});
const emit = defineEmits([ 'input', 'close', 'focus' ]);

//region INPUT MANAGEMENT
const previousValue = ref();
const onInput = (event) => {
    const searchValue = event.target.value;

    if (previousValue.value && previousValue.value.trim() === searchValue.trim()) return;

    emit('input', searchValue.trim());
    model.value = searchValue.trim();
  }
//endregion

//region CLOSE
const showCloseIcon = computed(() => model.value !== '');
const onCloseClick = () => {
    previousValue.value = '';
  emit('close');
  }
//endregion

//region FOCUS
  const onFocus = () => {
    emit('focus');
  }
//endregion

//region KEYBOARD ACTIONS
const onArrowUp = () => useItemListStore().navigatePreviousIndex();
const onArrowDown = () => useItemListStore().navigateNextIndex();
const onEnter = () => useItemListStore().openItem();
//endregion
</script>

<template>
  <form>
    <div class="form-container-input">
      <div class="d-flex align-items-center form-search-zone">
        <SearchIcon />
        <input
          class="form-control"
          type="text"
          :placeholder="$t('search.tree-view.search.terminology')"
          name="text"
          autocomplete="off"
          :value="model"
          @input="onInput($event)"
          @focus="onFocus()"
          @keyup.up.prevent="onArrowUp()"
          @keydown.up.prevent
          @keyup.down.prevent="onArrowDown()"
          @keydown.down.prevent
          @keyup.enter.prevent="onEnter()"
          @keydown.enter.prevent
            @click="onFocus"
        />
      </div>
      <div v-if="showCloseIcon" class="container-svg-close" @click="onCloseClick()">
        <CrossSmallIcon />
      </div>
    </div>
  </form>
</template>

<style scoped lang="scss">
@use '/assets/css/theme/helpers/variables';

form {

  .form-container-input:focus-within {
    border-color: variables.$input-focus-border-color;
  }

  .form-container-input {
    width: 100%;
    height: 42px;
    padding: 6px 5px 6px 10px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border: 1px solid variables.$input-border-color;
    display: flex;
    justify-content: space-between;

    .form-search-zone {
      width: 100%;
    }

    .container-svg-close {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      cursor: pointer;
      border-radius: 20px;
      padding: 4px;
      width: 33px;

      &:hover {
        background-color: variables.$icon-accordion;
      }
    }


    input {
      border: none;
      outline: none;
      width: 100%;
      float: left;
      font-size: 14px;
    }
  }
}
</style>
